<template>
  <div>
    <div>
      <Button _key="btnCreate" title="Produto" classIcon="fas fa-plus-circle" type="primary" size="small"
        :clicked="create" />
    </div>
    <Modal title="Produtos" :width="1200" :height="750" v-show="showModal('addProduct')"
      :onHideModal="hideSearchProduct">
      <SearchProduct v-if="showSearchProduct" :types="'1,2,3,4,5'" :status="1" :showPrice="true"
        :showAvailability="false" :addProduct="addProduct">
      </SearchProduct>
    </Modal>
  </div>
</template>

<script>

import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";

import SearchProduct from '../../stock/search-product/SearchProduct.vue';

import ItemsSupplierOrder from "./ItemsSupplierOrder.js";

import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "ItemsSupplierOrderCreate",
  components: {
    Button,
    Modal,
    SearchProduct,
  },
  props: {
    supplierOrder: Object,
  },
  data() {
    return {
      itemsSupplierOrder: new ItemsSupplierOrder(),
      urlCreate: "/api/v1/supplier/items-supplier-order/create",
      showSearchProduct: false,
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    ...mapActions("generic", ["postApi"]),
    create() {
      this.openModal("addProduct");
      this.removeLoading(["btnCreate"]);
      this.showSearchProduct = true;
    },
    addProduct(product) {
      this.updateClassItemSupplierOrder(product);
      let params = { url: this.urlCreate, obj: this.itemsSupplierOrder };
      this.postApi(params).then(() => {
        this.addEvent({
          name: "addedProduct",
        });
        this.removeLoading([product.id]);
      });
    },
    hideSearchProduct() {
      this.showSearchProduct = false;
    },
    updateClassItemSupplierOrder(data) {
      this.itemsSupplierOrder.productId = data.id;
      this.itemsSupplierOrder.productFullName = data.productFullName;
      this.itemsSupplierOrder.description = data.description;
      this.itemsSupplierOrder.quantity = data.quantity;
      this.itemsSupplierOrder.unitValue = data.value;
      this.itemsSupplierOrder.supplierOrderId = this.supplierOrder.id;
    },
  },
};
</script>
